/**
 * Node glyphs for the landing page's automation-flow animation: outline
 * strokes on a 24-unit grid, `currentColor`, sized by the caller's class.
 */

type FlowIconProps = { className?: string }

function FlowIcon({
  className,
  strokeWidth,
  d,
}: FlowIconProps & { strokeWidth: number; d: string }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d={d}
      />
    </svg>
  )
}

/** Lightning bolt — the trigger node. */
export function FlowTriggerIcon(props: FlowIconProps) {
  return (
    <FlowIcon {...props} strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
  )
}

/** Envelope — a send-email node. */
export function FlowMailIcon(props: FlowIconProps) {
  return (
    <FlowIcon
      {...props}
      strokeWidth={2}
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  )
}

/** Clock face — a wait node. */
export function FlowClockIcon(props: FlowIconProps) {
  return (
    <FlowIcon
      {...props}
      strokeWidth={2}
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  )
}

/** Magnifier in a circle — a filter node. */
export function FlowFilterIcon(props: FlowIconProps) {
  return (
    <FlowIcon
      {...props}
      strokeWidth={2}
      d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  )
}
